/**
 * Generate an array of indices for skeleton rendering.
 * Returns [0, 1, 2, ..., count - 1].
 */
export function generateSkeletonArray(count: number): number[] {
  return Array.from({ length: Math.max(0, count) }, (_, i) => i);
}
